import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { ArrowLeft, Printer } from "lucide-react";

export default function IssueSlipPrint() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [slip, setSlip] = useState(null);

  useEffect(() => {
    api.get(`/issue-slips/${id}`).then((r) => setSlip(r.data));
  }, [id]);

  if (!slip) return <div className="p-8 text-sm text-slate-500">Loading slip…</div>;

  return (
    <div className="min-h-screen bg-slate-100 py-8">
      <div className="no-print max-w-[700px] mx-auto px-4 mb-4 flex justify-between">
        <button onClick={() => navigate(-1)} className="text-sm text-slate-600 hover:text-slate-900 inline-flex items-center gap-2">
          <ArrowLeft size={14} /> Back
        </button>
        <button onClick={() => window.print()} data-testid="print-issue-btn" className="bg-[#1D2951] hover:bg-[#2B3A67] text-white px-4 py-2 rounded-md text-sm font-semibold inline-flex items-center gap-2">
          <Printer size={14} /> Print
        </button>
      </div>

      <div className="print-page bg-white max-w-[700px] mx-auto p-10 shadow-sm border border-slate-200 text-slate-900" data-testid="issue-slip-page">
        <div className="border-b-2 border-slate-900 pb-3 flex justify-between items-end">
          <div>
            <div className="text-xl font-bold uppercase tracking-wider">Stores Issue Slip</div>
            <div className="text-xs text-slate-600 mt-1 font-mono">{slip.slip_number}</div>
          </div>
          <div className="text-right text-xs">
            <div><span className="text-slate-500">Date:</span> {slip.created_at?.slice(0, 10)}</div>
            <div><span className="text-slate-500">PO No:</span> <span className="font-mono font-semibold">{slip.po_number}</span></div>
          </div>
        </div>

        <div className="mt-4 grid grid-cols-3 gap-4 text-sm">
          <div>
            <div className="text-[10px] uppercase tracking-widest text-slate-500">Issued To</div>
            <div className="font-semibold">{slip.department}</div>
          </div>
          <div>
            <div className="text-[10px] uppercase tracking-widest text-slate-500">Indentor</div>
            <div className="font-semibold">{slip.intender_name || "—"}</div>
          </div>
          <div>
            <div className="text-[10px] uppercase tracking-widest text-slate-500">Issued By</div>
            <div className="font-semibold">{slip.issued_by}</div>
          </div>
        </div>

        <table className="w-full mt-6 text-sm border border-slate-900">
          <thead>
            <tr className="bg-slate-900 text-white">
              <th className="px-2 py-1.5 border border-slate-900 w-10 text-center">S.N.</th>
              <th className="px-2 py-1.5 border border-slate-900 text-left">Item Name</th>
              <th className="px-2 py-1.5 border border-slate-900 text-center">Item Code</th>
              <th className="px-2 py-1.5 border border-slate-900 text-right">Qty Issued</th>
              <th className="px-2 py-1.5 border border-slate-900 text-center">Unit</th>
            </tr>
          </thead>
          <tbody>
            {slip.items.map((it, idx) => (
              <tr key={idx}>
                <td className="px-2 py-1.5 border border-slate-300 text-center font-mono">{idx + 1}</td>
                <td className="px-2 py-1.5 border border-slate-300">{it.description}</td>
                <td className="px-2 py-1.5 border border-slate-300 text-center font-mono">{it.item_code || "—"}</td>
                <td className="px-2 py-1.5 border border-slate-300 text-right font-mono">{it.quantity}</td>
                <td className="px-2 py-1.5 border border-slate-300 text-center">{it.unit}</td>
              </tr>
            ))}
            {Array.from({ length: Math.max(0, 4 - slip.items.length) }).map((_, i) => (
              <tr key={`pad-${i}`}>
                {Array.from({ length: 5 }).map((__, j) => (<td key={j} className="px-2 py-1.5 border border-slate-300">&nbsp;</td>))}
              </tr>
            ))}
          </tbody>
        </table>

        <div className="mt-16 grid grid-cols-3 gap-6 text-xs">
          {["Issued By", "Received By", "Authorised Signatory"].map((l) => (
            <div key={l} className="text-center">
              <div className="border-t border-slate-900 pt-1 mt-12">{l}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
